<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paginationOption: {
        total: this.pagination.total || 100,
        current: this.pagination.current_page || 10,
        perPage: this.pagination.per_page || 10,
        rangeBefore: 3,
        rangeAfter: 1,
        order: 'is-centered',
        size: '',
        isSimple: false,
        isRounded: true,
        prevIcon: '',
        nextIcon: ''
      }
    }
  },
  methods: {
    handleChange(number) {
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          p: number
        }
      })
    }
  }
}
</script>
<template>
  <b-pagination
    :total="paginationOption.total"
    :current.sync="paginationOption.current"
    :range-before="paginationOption.rangeBefore"
    :range-after="paginationOption.rangeAfter"
    :order="paginationOption.order"
    :size="paginationOption.size"
    :simple="paginationOption.isSimple"
    :rounded="paginationOption.isRounded"
    :per-page="paginationOption.perPage"
    :icon-prev="paginationOption.prevIcon"
    :icon-next="paginationOption.nextIcon"
    aria-next-label="Next page"
    aria-previous-label="Previous page"
    aria-page-label="Page"
    aria-current-label="Current page"
    @change="handleChange"
  >
  </b-pagination>
</template>
<style lang="scss" module>

</style>
